// eslint-disable-next-line import/no-anonymous-default-export
export default {
  brEntitlements: {
    list: [],
    loader: false,
  },
  entitlement: {
    loader: false,
    list: [],
    brEntitlements: [],
  },
  entitlementDetail: {
    loader: false,
    beneficiaryList: [],
    detail: {},
  },
};
